interface DragState {
  isDragging: boolean
  id: string | null
}

interface GraphRootState {
  graph?: {
    drag?: DragState
  }
}

const defaultDragState: DragState = {
  isDragging: false,
  id: null,
}


const selectDrag = (state: Record<string, unknown>): DragState => {
  const graph = (state as GraphRootState).graph
  return graph?.drag ?? defaultDragState
}

export default selectDrag
